import * as z from "zod";

// Mints a fresh hosted Gale identity-verification (Adyen) link for the
// authenticated team from the KYC payload an admin previously validated and
// saved. The merchant lands on the conversion KYC redirect page, which calls
// this and forwards them to `onboardingUrl`. No input — the team comes from
// auth, and the saved payload is looked up server-side.
export const startGaleKyc = {
  name: "startGaleKyc" as const,
  input: z.null(),
  output: z.object({ onboardingUrl: z.string() }),
};
